import {Autocomplete, Box, Image, Select, Tabs, Text} from '@mantine/core';
import {useRouter} from 'next/router';
import {type FC, useCallback, useEffect} from 'react';
import {REPORT_ANALYTICS_BUTTON_DEFAULT} from '../../../../config/constants/img';
import {useMediaQuery} from '../../../../shared/services/useMediaQuery';
import {getAIGradient} from '../../usecase/getAIGradient';
import {useHandleReportAnalyticsSearch} from '../../usecase/useHandleReportAnalyticsSearch';

type Props = {
  reportType: string;
  isActive: boolean;
  setCompaniesCount: (count: number) => void;
};

export const TabsPanel: FC<Props> = ({
  reportType,
  isActive,
  setCompaniesCount,
}) => {
  const router = useRouter();
  const {isPC} = useMediaQuery();

  const {
    searchWord,
    autoCompleteData,
    handleSearchInputChange,
    convertDepartmentItems,
    selectedCompanyId,
    setSelectedCompanyId,
    selectedDepartmentId,
    setSelectedDepartmentId,
    setDepartmentItems,
  } = useHandleReportAnalyticsSearch({reportType});

  const handlePressStart = useCallback(() => {
    location.href = `/report_analytics/result/${selectedCompanyId}/${selectedDepartmentId}?reportType=${reportType}`;
  }, [router, selectedCompanyId, selectedDepartmentId]);

  useEffect(() => {
    if (autoCompleteData.length > 0 && reportType === 'intern' && isActive) {
      setCompaniesCount(autoCompleteData.length);
    }
  }, [autoCompleteData]);

  useEffect(() => {
    if (autoCompleteData.length > 0 && isActive) {
      setCompaniesCount(autoCompleteData.length);
    }
  }, [isActive]);

  return (
    <Tabs.Panel value={reportType}>
      <Box className="flex flex-col items-center mt-16">
        <Autocomplete
          placeholder={'企業名を入力して選択'}
          itemComponent={(props) => (
            <>
              {!selectedCompanyId && (
                <Text
                  onClick={() => {
                    handleSearchInputChange(props.value);
                    setSelectedCompanyId(props.id);
                    setSelectedDepartmentId('0');
                  }}
                  className="border-b-2 cursor-pointer flex items-center line-clamp-2 hover:underline text-primary py-8 p-4"
                >
                  {props.value}
                </Text>
              )}
            </>
          )}
          data={autoCompleteData}
          value={searchWord}
          onChange={(searchWord) => {
            handleSearchInputChange(searchWord);
            setDepartmentItems([]);
            setSelectedDepartmentId('0');
          }}
          onDropdownOpen={() => {
            setSelectedCompanyId(undefined);
          }}
          size="md"
          dropdownPosition="bottom"
          className="pc:w-[320px] w-full"
          limit={1000}
          maxDropdownHeight={320}
        />
        <Select
          value={selectedDepartmentId}
          placeholder="部門・職種を選択してください"
          data={convertDepartmentItems}
          maxDropdownHeight={500}
          size={isPC ? 'md' : 'md'}
          onChange={(value) => {
            if (value) setSelectedDepartmentId(value);
          }}
          className="pc:w-[320px] w-full line-clamp-2 mt-16"
        />
        {selectedCompanyId &&
        selectedDepartmentId &&
        selectedDepartmentId !== '0' ? (
          <Box
            className={
              'rounded-[32px] pc:w-[320px] w-full h-64 flex items-center justify-center pc:mt-24 mt-20 cursor-pointer'
            }
            onClick={
              selectedCompanyId &&
              selectedDepartmentId &&
              selectedDepartmentId !== '0'
                ? handlePressStart
                : undefined
            }
            style={{
              background: getAIGradient(),
            }}
          >
            <Text className="text-lg text-white font-bold">
              AI分析をはじめる
            </Text>
          </Box>
        ) : (
          <Box>
            <Image
              src={REPORT_ANALYTICS_BUTTON_DEFAULT}
              className="w-[320px] h-64 mt-24 cursor-not-allowed"
            />
          </Box>
        )}
      </Box>
    </Tabs.Panel>
  );
};
